import axios from "axios";
import Cookies from "js-cookie";

// Create the axios instance
const http = axios.create({
  // Choose the appropriate base URL for your environment
  baseURL: "https://s-qc.in/",
  // baseURL: "http://localhost:4005/",
  headers: {
    "Content-type": "application/json",
  },
  // Enable cookies with credentials
  // withCredentials: true
});

// Add a request interceptor to automatically add auth token
http.interceptors.request.use(
  (config) => {
    // Try to get token from cookies first, then localStorage
    const token = Cookies.get('auth_token') || localStorage.getItem('token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle auth errors
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 (Unauthorized) errors
    if (error.response && error.response.status === 401) {
      // Clear auth data
      Cookies.remove('auth_token');
      Cookies.remove('auth_user_id');
      Cookies.remove('auth_email');
      Cookies.remove('auth_type');
      Cookies.remove('auth_username');
      // Cookies.remove('auth_first_login');
      
      localStorage.removeItem('token');
      localStorage.removeItem('_id');
      localStorage.removeItem('email');
      localStorage.removeItem('type');
      localStorage.removeItem('username');
      // localStorage.removeItem('first_login');
      localStorage.removeItem('user');
      
      // Redirect to login page if not already there
      if (window.location.pathname !== '/login' && 
          window.location.pathname !== '/signup' &&
          window.location.pathname !== '/verify-email') {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default http;